import { Notify } from '@flexisaf/flexibull2';
import {
  AssessmentConfigurationDto,
  AssessmentConfigurationRestControllerService,
  SubAssessmentBreakdownRequest,
} from 'generated';
import { useCallback, useState } from 'react';
import { apiWrapper } from 'utils/http-client';
import { handleError } from 'utils/utils';

export const useAssessmentBreakdownGet = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [content, setContent] = useState<AssessmentConfigurationDto>({});

  const fetchAssessmentBreakdown = useCallback(
    async (payload: {
      armId?: string | undefined;
      classLevelId?: string | undefined;
      subjectId?: string | undefined;
      termId?: string | undefined;
    }) => {
      setLoading(true);
      try {
        const response = await apiWrapper(() =>
          AssessmentConfigurationRestControllerService.getAssessmentBreakdownsUsingGet(payload),
        );

        const sortedResponse: AssessmentConfigurationDto = {
          ...response,
          assessments_and_breakdowns: (response?.assessments_and_breakdowns || [])?.sort((a, b) => {
            if ((a?.assessment?.assessment_order || 0) > (b?.assessment?.assessment_order || 0)) {
              return 1;
            }
            if ((a?.assessment?.assessment_order || 0) < (b?.assessment?.assessment_order || 0)) {
              return -1;
            }
            return 0;
          }),
        };

        setLoading(false);
        setContent(sortedResponse);
        return { success: true, response: sortedResponse };
      } catch (error) {
        setContent({});
        setLoading(false);
        handleError(error);
        return { success: false, response: {} };
      }
    },
    [],
  );

  return {
    loadingAssessmentBreakdown: loading,
    fetchAssessmentBreakdown,
    assessmentBreakDownContent: content,
  };
};

export const useSubBreakdowPut = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [content, setContent] = useState<any>({});

  const saveSubBreakdown = useCallback(async (payload: SubAssessmentBreakdownRequest) => {
    setLoading(true);
    try {
      const response = await apiWrapper(() =>
        AssessmentConfigurationRestControllerService.updateAssessmentSubBreakdownUsingPut({
          request: payload,
        }),
      );

      setLoading(false);
      setContent(response);
      return { success: true, response: response };
    } catch (error) {
      setContent({});
      setLoading(false);
      handleError(error);
      return { success: false, response: {} };
    }
  }, []);

  return {
    loadingSave: loading,
    saveSubBreakdown,
  };
};

export const useSubBreakdownDelete = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [content, setContent] = useState<any>({});

  const deleteSubBreakdown = useCallback(
    async (payload: { assessmentBreakdownId: string; subAssessmentBreakdownId: string }) => {
      setLoading(true);

      try {
        const response = await apiWrapper(() =>
          AssessmentConfigurationRestControllerService.deleteAssessmentSubBreakdownUsingDelete(
            payload,
          ),
        );

        setLoading(false);
        setContent(response);
        Notify('Sub-assessment deleted successfully', { status: 'success' });
        return { success: true, response: response };
      } catch (error) {
        setContent({});
        setLoading(false);
        handleError(error);
        return { success: false, response: {} };
      }
    },
    [],
  );

  return {
    loadingDelete: loading,
    deleteSubBreakdown,
    deleteContent: content,
  };
};
